import React, { useCallback } from 'react';
import { PiEnvelopeSimple } from 'react-icons/pi';
import { useParams } from 'react-router-dom';
import { Input } from 'rizzui';
import AsyncImg from '../../../../../components/extras/AsyncImg';
import PlaceholderImage from '../../../../../components/extras/PlaceholderImage';
import CustomSelect from '../../../../../components/forms/CustomSelect';
import useFetch from '../../../../../hooks/useFetch';
import FormGroup from '../../../../../layout/shared/form-group';
import { UserService } from '../../../../../services/user/userService';
import { UserApiResponse } from '../../../../../type/entities/user-type';
import PhoneInput from '../../../../../components/forms/PhoneInputWrapper';

interface UserInfoProps { }

const UserInfo: React.FC<UserInfoProps> = () => {

    // HOOKS

    const { id = '' } = useParams<{ id: string }>();
    const service = new UserService();

    // DATA FETCHING

    const [data] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await service.getUserById(id);
        return response.getResponseData() as UserApiResponse;
    }, [id]));

    // FUNCTIONS

    //----------------------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER LOS ROLES DEL USUARIO
     * @EN GET USER ROLES
     */
    //----------------------------------------------------------------------------------------------------------------------------
    function getUserRolesValues() {
        return data?.userRoles.map((roleWrapper: any) => (
            { value: roleWrapper.role.id, label: roleWrapper.role.name }
        ));
    };
    //----------------------------------------------------------------------------------------------------------------------------

    // RENDER

    return (
        <>
            <div className="@container">
                <div className="grid divide-y-2 divide-dashed divide-gray-200 gap-6">
                    <FormGroup
                        title="Datos Personales"
                        description='Información personal del usuario'
                        className='pt-3 pb-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-4"
                    >
                        <div className='md:col-span-2 md:grid md:grid-cols-3 gap-4'>
                            <Input
                                disabled
                                label="Nombre"
                                placeholder="First Name"
                                value={data?.name ?? ''}
                                className="flex-grow"
                            />

                            <Input
                                disabled
                                label="Apellidos"
                                placeholder="Last Name"
                                value={data?.lastName ?? ''}
                                className="flex-grow"
                            />

                            <Input
                                disabled
                                label="DNI"
                                placeholder="dni"
                                value={data?.dni ?? ''}
                                className="flex-grow"
                            />

                            <PhoneInput
                                id='phone'
                                label='Teléfono'
                                className=''
                                value={data?.phone ?? ''}
                                required={false}
                                disabled
                            />

                            <Input
                                disabled
                                prefix={<PiEnvelopeSimple className="h-6 w-6 text-gray-500" />}
                                type="email"
                                label="Email"
                                placeholder="georgia.young@attiva.com"
                                value={data?.email ?? ''}
                                className="md:col-span-2"
                            />
                        </div>

                        <div></div>

                        {data?.profileImg?.id
                            ? <AsyncImg id={data?.profileImg?.id} isBackground className="mx-auto d-block img-fluid rounded w-[220px] h-[220px] object-cover" />
                            : <PlaceholderImage width={200} height={200} className='mx-auto d-block img-fluid rounded' />
                        }
                    </FormGroup>

                    <FormGroup
                        title="Otros datos"
                        description="Información adicional de la cuenta"
                        className='pt-3 pb-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-4"
                    >
                        <CustomSelect
                            isDisabled
                            id={'roleId'}
                            label="Rol del usuario"
                            value={getUserRolesValues()}
                        />
                        
                    </FormGroup>
                </div>
            </div>
        </>
    );
};

export default UserInfo;